import React from 'react';
import PropTypes from 'prop-types';

export default function BaseDialogLayoutContent(props) {
  const { content, children, contentClassName, html } = props;
  const result = children || content;

  if (!result && !html) {
    return null;
  }

  if (html) {
    // eslint-disable-next-line react/no-danger
    return <section className={`base-dialog-layout-content-wrapper ${contentClassName}`} dangerouslySetInnerHTML={{ __html: html }} />;
  }
  return <section className={`base-dialog-layout-content-wrapper ${contentClassName}`}>{result}</section>;
}

BaseDialogLayoutContent.propTypes = {
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  contentClassName: PropTypes.string,
  children: PropTypes.node,
  html: PropTypes.string,
};
